import React, {useEffect} from "react";
import {contribution_dump} from "../data/contribution_dump";

interface Props {
    part: string,
    song_title: string

}

const useVocalParts = ({part, song_title}: Props) => {
    const [showContributions, setShowContributions] = React.useState(false);
    const [contributions, setContributions] = React.useState(contribution_dump);

    useEffect(() => {
        // Get contributions
        setContributions(contribution_dump.filter((item => item.part_type === part && item.song_title === song_title)))

    }, [part, showContributions, song_title])

    return {showContributions, setShowContributions, contributions}
}

export default useVocalParts;